import { ErrorInfo as EN_ERROR_INFO } from '../common/error-info';
import { isLocalStorageEnabled } from '../utils/environment';
import loggerManager from '../utils/log/logger-manager';
import { BASE_DOC_URL, STORAGE_EXPIRES_TIME, TRTC_ERROR_ASSISTANCE, innerVersion } from './constants';
import { isLangChinese, isFunction, isString  } from '../utils/utils';

// 加载本地错误信息
// import '../../../../scripts/trtc-error-assistance.js';

// v4.11.7-v4.11.8 加载该路径的中文错误信息
// const errorUrl = 'https://web.sdk.qcloud.com/trtc/webrtc/download/trtc-error-assistance.js';
// v4.11.9及其以上版本加载该路径的中文错误信息
const errorUrl = 'https://web.sdk.qcloud.com/trtc/webrtc/download/error-message/0.0.2/script.js';

const getDocUrl = (language: string, docPath: string) => {
  if (docPath) {
    return `${BASE_DOC_URL}/${language}/${docPath}`;
  }
  return `${BASE_DOC_URL}/${language}/index.html`;
};
/**
 * 判断是否超时
 * @return {boolean}
 */
const isErrorDataNeedToUpdate = (errorData: any) => {
  // 7天超时
  const isTimeout =
    errorData.saveTime && new Date().getTime() - errorData.saveTime >= STORAGE_EXPIRES_TIME;
  // 版本不同重新加载
  const isDifferentVersion = !errorData.saveVersion || errorData.saveVersion !== innerVersion;
  return isTimeout || isDifferentVersion;
};

/**
 * 获取 error info 和 error link
 * @return {object}
 */
const getErrorDataFromLocalStorage = () => {
  // @ts-ignore
  if (window.TRTC_ERROR_INFO && window.TRTC_ERROR_LINK) {
    return {
      // @ts-ignore
      TRTC_ERROR_INFO: window.TRTC_ERROR_INFO, TRTC_ERROR_LINK: window.TRTC_ERROR_LINK
    };
  }
  let errorAssistance: any = localStorage?.getItem(TRTC_ERROR_ASSISTANCE);
  if (errorAssistance) {
    errorAssistance = JSON.parse(errorAssistance);
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = errorAssistance.message;
    document.body.appendChild(script);
    // @ts-ignore
    const info = window.TRTC_ERROR_INFO;
    // @ts-ignore
    const link = window.TRTC_ERROR_LINK;
    document.body.removeChild(script);
    return {
      TRTC_ERROR_INFO: info,
      TRTC_ERROR_LINK: link
    };
  }

  return {};
};

/**
 * 同步请求 cos 获取 error 信息配置文件
 */
const requestErrorInfo = () => {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', errorUrl, false);
  xhr.send(null);
  if (xhr.readyState === 4 && xhr.status === 200) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = xhr.responseText;
    document.body.appendChild(script);
    localStorage.setItem(
      TRTC_ERROR_ASSISTANCE,
      JSON.stringify({
        message: xhr.responseText,
        saveTime: new Date().getTime(),
        saveVersion: innerVersion
      })
    );
    document.body.removeChild(script);
  }
};

/**
 * SDK setLogLevel 时 加载一下错误信息的配置，未过期则使用localStorage，过期则请求。
 */
export const getErrorInfo = () => {
  if (!isLocalStorageEnabled()) {
    return false;
  }
  const errorData = localStorage.getItem(TRTC_ERROR_ASSISTANCE);
  // no error data or timeout
  if (!errorData || isErrorDataNeedToUpdate(JSON.parse(errorData))) {
    loggerManager.info('init debug info');
    requestErrorInfo();
  }
};

/**
 * 拼接 error message
 * @export
 * @param {object} options
 * @param {string} options.key
 * @param {string} options.data
 * @return {string}
 */
export function generateErrorMessage(options: any) {
  const { key, data, link, addDocLink = true } = options;

  let enMessage = '';
  let cnMessage = '';
  let docPath = '';

  // En error message
  // @ts-ignore
  if (isFunction(EN_ERROR_INFO[key])) {
    // @ts-ignore
    enMessage = EN_ERROR_INFO[key](data);
    // @ts-ignore
  } else if (isString(EN_ERROR_INFO[key])) {
    // @ts-ignore
    enMessage = EN_ERROR_INFO[key];
  }

  const { TRTC_ERROR_INFO, TRTC_ERROR_LINK } = getErrorDataFromLocalStorage();

  if (link) {
    docPath = `${link.className}.html#${link.fnName}`;
  } else if (TRTC_ERROR_LINK && TRTC_ERROR_LINK[key]) {
    if (isFunction(TRTC_ERROR_LINK[key])) {
      docPath = TRTC_ERROR_LINK[key](data);
    } else if (isString(TRTC_ERROR_LINK[key])) {
      docPath = TRTC_ERROR_LINK[key];
    }
  }

  // 默认显示英文提示, 在log level 为debug模式下加载额外的提示信息后, 在中文系统下才会显示中文和对应语言的文档链接
  // 提示信息完整组成: [time] <TYPE> '中文提示', 请查看文档: '中文链接'。'英文提示'， Refer to: '英文链接'
  let errorMessage = enMessage;
  if (isLangChinese()) {
    // Zh error message
    if (TRTC_ERROR_INFO && TRTC_ERROR_INFO[key]) {
      if (isFunction(TRTC_ERROR_INFO[key])) {
        cnMessage = TRTC_ERROR_INFO[key](data);
      } else if (isString(TRTC_ERROR_INFO[key])) {
        cnMessage = TRTC_ERROR_INFO[key];
      }
    }
    if (cnMessage) {
      if (addDocLink) {
        errorMessage = `${cnMessage}\n请查看文档: ${getDocUrl('zh-cn', docPath)}\n\n`;
      } else {
        errorMessage = `${cnMessage}\n\n`;
      }
      errorMessage += enMessage;
    }
  }

  // 在英文提示信息后加上文档链接。
  if (addDocLink) {
    errorMessage += ` \nRefer to: ${getDocUrl('en', docPath)}\n`;
  }
  return errorMessage;
}
